import { gql } from 'apollo-angular';

const GET_CATEGORY = gql`
  query category($id: Long!) {
    category(id: $id) {
      id
      name
      type
      effectiveDate
      categorizationScheme {
        id
        name
      }
      parent {
        id
        name
        type
      }
    }
  }
`;

export default GET_CATEGORY;
